/**
 * Wholesale collection template: guests cannot navigate to PDP from product cards.
 * Opens the B2B contact modal instead. 
 */
const GUEST_LOCK_BODY_CLASS = 'wholesale-collection--guest-locked';
const MODAL_COMPONENT_ID = 'wholesale-collection-guest-modal-component';

const isGuestLocked = () => document.body.classList.contains(GUEST_LOCK_BODY_CLASS);

const getModalComponent = () => document.getElementById(MODAL_COMPONENT_ID);

const openGuestModal = () => {
  const modalComponent = getModalComponent();
  if (!modalComponent || typeof modalComponent.showDialog !== 'function') return;
  modalComponent.showDialog();
};

const isInsideGuestModal = (target) => {
  if (!(target instanceof Element)) return false;
  return Boolean(target.closest('#wholesale-collection-guest-modal'));
};

const isInteractiveTarget = (target) => {
  if (!(target instanceof Element)) return false;
  return Boolean(target.closest('button, input, label, select, textarea'));
};

const isProductCardTarget = (target) => {
  if (!(target instanceof Element)) return false;
  return Boolean(
    target.closest(
      '.product-grid__item, product-card, .product-card, .resource-list__item product-card, recently-viewed-products product-card'
    )
  );
};

const onDocumentClick = (event) => {
  if (!isGuestLocked()) return;
  if (isInsideGuestModal(event.target)) return;
  if (!isProductCardTarget(event.target)) return;
  if (isInteractiveTarget(event.target)) return;

  const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
  if (link) {
    event.preventDefault();
    event.stopPropagation();
  }

  openGuestModal();
};

const onDocumentClickCapture = (event) => {
  if (!isGuestLocked()) return;
  if (isInsideGuestModal(event.target)) return;
  if (!isProductCardTarget(event.target)) return;
  if (isInteractiveTarget(event.target)) return;

  const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
  if (!link) return;

  event.preventDefault();
  event.stopPropagation();
  openGuestModal();
};

const initWholesaleCollectionGuestLock = () => {
  if (!isGuestLocked()) return;

  document.addEventListener('click', onDocumentClickCapture, true);
  document.addEventListener('click', onDocumentClick);

  // Toon de modal automatisch 1 seconde na laden
  setTimeout(openGuestModal, 1000);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWholesaleCollectionGuestLock, { once: true });
} else {
  initWholesaleCollectionGuestLock();
}